import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuthStore } from '@/lib/store';

export default function SplashPage() {
  const navigate = useNavigate();
  const { user, loading } = useAuthStore();
  useEffect(() => {
    const t = setTimeout(() => {
      if (loading) return;
      navigate(user ? '/' : '/login', { replace: true });
    }, 1400);
    return () => clearTimeout(t);
  }, [navigate, user, loading]);

  return (
    <div className="min-h-dvh relative overflow-hidden bg-background" data-testid="splash-screen">
      <img src="https://images.unsplash.com/photo-1600168488589-d88081e77cd0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 gradient-signature opacity-75" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent" />
      <div className="relative z-10 min-h-dvh flex flex-col items-center justify-center text-white px-6">
        <motion.img
          initial={{ scale: 0.92, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          src="/logo-icon.png"
          alt="Memoir"
          data-testid="splash-logo"
          className="h-24 w-24 sm:h-28 sm:w-28 rounded-3xl shadow-2xl bg-white/95 p-2"
        />
        <motion.h1
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25, duration: 0.5 }}
          className="font-serif mt-6 text-5xl font-bold"
        >
          Memoir<sup className="text-base align-super ml-1 font-medium">™</sup>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          data-testid="splash-tagline"
          className="mt-2 text-base sm:text-lg tracking-wide text-white/90"
        >
          Capture. Share. Remember.
        </motion.p>
      </div>
    </div>
  );
}
